@if (count > 5) {
  <p-paginator
    dir="ltr"
    [rows]="rows"
    [totalRecords]="count"
    [rowsPerPageOptions]="pageSizeOptions"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="lang === 'ar' ?
      'عرض {first} إلى {last} من {totalRecords}' :
      'Showing {first} to {last} of {totalRecords}'"
    (onPageChange)="onPageChange($event)">
  </p-paginator>
  }
